import styled from "styled-components";

export default styled.div`
  
  &.input-wrapper {
    width: 100%;
    position: relative;
    text-align: left;
  }
  .passwordIconShowHide {
    position: absolute;
    right: 10px;
    bottom: 4px;
    padding: 8px;
    border-radius: 50%;
    svg {
      fill: rgba(0, 0, 0, 0.54);
    }
    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }
  }
  .input-error {
    font-family: Poppins !important;
    font-size: 12px !important;
    color: rgb(211, 47, 47);
  }
`;
